import {Component, Input} from '@angular/core';
import {BreakpointConfig} from '../../website-states.enum';
import {WebsiteStatesService} from '../../website-states.service';
import {LoanApplication} from '../../@models/loan-application.model';

@Component({
  selector: 'bb-requirements-figures',
  templateUrl: './requirements-figures.component.html',
  styleUrls: ['./requirements-figures.component.scss'],
})
export class RequirementsFiguresComponent {
  @Input() employmentType;
  type = LoanApplication.EmploymentType;
  padding = this.website.viewport
    .map((config: BreakpointConfig) => {
      if (config.gteXSmall) {
        return '1em';
      }
      return '2em';
    })
    .shareReplay(1);

  constructor(private website: WebsiteStatesService) {
  }
}
